import { Component, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { NotFoundModalComponent } from "@modules/main/components/not-found-modal/not-found-modal.component";

@Component({
	selector: "trade-not-found-dialog",
	template: "",
	standalone: false
})
export class TradeNotFoundDialogComponent implements OnInit {
	constructor(private modalService: ModalService) {}

	public ngOnInit(): void {
		this.modalService.create(NotFoundModalComponent).present();
	}
}
